// extracted by mini-css-extract-plugin
export default {"tagsGroup":"tagsGroup--u9ze7","groupTitle":"groupTitle--HB4rR","text":"text--WpqkQ","list":"list--JQXD6"};